import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://nodejsjawara.setwandprdjakarta.id/api';
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_BASE_URL, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jawara_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, Promise.reject);

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('jawara_token');
      localStorage.removeItem('jawara_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
